import { useEffect, useState } from "react";

function PrecioAnimado({ valor }) {
  const [mostrado, setMostrado] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setMostrado(valor);
      return;
    }

    const duracion = 650;
    const inicio = performance.now();
    let frame;

    const paso = (ahora) => {
      const progreso = Math.min((ahora - inicio) / duracion, 1);
      const facilitado = 1 - Math.pow(1 - progreso, 3);
      setMostrado(Math.round(valor * facilitado));
      if (progreso < 1) {
        frame = requestAnimationFrame(paso);
      }
    };

    frame = requestAnimationFrame(paso);
    return () => cancelAnimationFrame(frame);
  }, [valor]);

  return <>{mostrado}</>;
}

export default PrecioAnimado;
